import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper, isBrowser } from './columnHelper'
import { NotApplicable, Unavailable } from './MissingData'

type EventsFilterSearch = {
  bot?: 'all' | 'good' | 'bad' | 'none'
}

const key = IdentificationUrlKeys.Bot
const label = visitFilterLabelMap[key]

export const botColumn = () =>
  columnHelper.display({
    id: 'bot',
    header: 'Bot',
    cell: ({ row }) => {
      if (!isBrowser(row.original)) {
        return <NotApplicable />
      }

      // Note: v4 enum types don't match v3 types, notDetected vs not_detected
      const botType = row.original.bot
      const searchMapping: Record<
        Exclude<'good' | 'bad' | 'not_detected' | undefined, undefined>,
        EventsFilterSearch['bot']
      > = {
        bad: 'bad',
        good: 'good',
        not_detected: 'none',
      }
      const searchValue = botType ? searchMapping[botType as 'good' | 'bad' | 'not_detected'] : undefined

      const copyMapping: Record<Exclude<'good' | 'bad' | 'not_detected' | undefined, undefined>, string> = {
        bad: 'Bad bot',
        good: 'Good bot',
        not_detected: 'Not detected',
      }

      if (botType == null) {
        return <Unavailable />
      }

      const text = copyMapping[botType as 'good' | 'bad' | 'not_detected']
      const colorClass = botType === 'bad' ? 'text-red-800' : botType === 'good' ? 'text-green-800' : ''

      return (
        <CellAction search={(old) => ({ ...old, [key]: searchValue })} field={label}>
          <Typography className={`text-nowrap ${colorClass}`}>{text}</Typography>
        </CellAction>
      )
    },
  })
